























import { Component, Vue, Prop } from "vue-property-decorator";
import * as modules from "../../../store/decorator";
import axios from "axios";

@Component
export default class VPurchaseOrderSurvey extends Vue {
    @Prop(String) value!: string;
    @Prop(String) id!: string;
    @Prop(String) customerId!: string;
    @Prop(String) status!: string;

    purchaseOrder: string = "";
    loading: boolean = false;

    async save() {
        this.loading = true;

        const purchaseOrder = this.purchaseOrder.trim();

        if (this.purchaseOrder !== purchaseOrder) {
            this.purchaseOrder = purchaseOrder;
        }

        const instance = axios.create();

        await this.$http
            .put(
                `${process.env.VUE_APP_DOT_NET_API_BASE_URL}${
                    process.env.VUE_APP_DOT_NET_API_SURVEY
                }/${this.id}/${this.customerId}/purchase-order/${
                    purchaseOrder
                }`,
                {},
                {
                    headers: {
                        Authorization: process.env.VUE_APP_V3_API_KEY
                    }
                }
            )
            .then(async (res: any) => {
                this.$emit("get-history");
            })
            .then(response => {
                this.loading = false;

                if (purchaseOrder)
                    return modules.root.snackbar("Purchase order added");
                return modules.root.snackbar("Purchase order removed");
            });
    }
}
